import api from './api';

export const productService = {
  // Categories
  getCategories: (params) => 
    api.get('/products/categories/', { params }),
  
  getCategory: (id) => 
    api.get(`/products/categories/${id}/`),
  
  createCategory: (data) => 
    api.post('/products/categories/', data),
  
  updateCategory: (id, data) => 
    api.put(`/products/categories/${id}/`, data),
  
  deleteCategory: (id) => 
    api.delete(`/products/categories/${id}/`),
  
  toggleCategoryStatus: (id) => 
    api.patch(`/products/categories/${id}/toggle-status/`),

  copyCategory: (id, data) => 
    api.post(`/products/categories/${id}/copy/`, data),

  // Menus
  getMenus: (params) => 
    api.get('/products/menu-types/', { params }),
  
  getMenu: (id) => 
    api.get(`/products/menu-types/${id}/`),
  
  createMenu: (data) => 
    api.post('/products/menu-types/', data),
  
  updateMenu: (id, data) => 
    api.put(`/products/menu-types/${id}/`, data),
  
  deleteMenu: (id) => 
    api.delete(`/products/menu-types/${id}/`),
  
  toggleMenuStatus: (id) => 
    api.patch(`/products/menu-types/${id}/toggle-status/`),

  copyMenu: (id, data) => 
    api.post(`/products/menu-types/${id}/copy/`, data),

  // Products
  getProducts: (params) => 
    api.get('/products/', { params }),
  
  getProduct: (id) => 
    api.get(`/products/${id}/`),
  
  createProduct: (data) => 
    api.post('/products/', data),
  
  updateProduct: (id, data) => 
    api.put(`/products/${id}/`, data),
  
  deleteProduct: (id) => 
    api.delete(`/products/${id}/`),
  
  toggleProductStatus: (id) => 
    api.patch(`/products/${id}/toggle-status/`),
  
  bulkUpdateProductStatus: (data) => 
    api.patch('/products/bulk/status/', data),

  bulkCopyMoveProducts: (data) => 
    api.post('/products/bulk/category/', data),

  bulkCopyToMenu: (data) => 
    api.post('/products/bulk/menu-copy/', data),

  copyProduct: (id, data) => 
    api.post(`/products/${id}/copy/`, data),

  // Variants
  getVariants: (productId) => 
    api.get(`/products/${productId}/variants/`),
  
  createVariant: (productId, data) => 
    api.post(`/products/${productId}/variants/`, data),
  
  updateVariant: (variantId, data) => 
    api.put(`/products/variants/${variantId}/`, data),
  
  deleteVariant: (productId, variantId) => 
    api.delete(`/products/${productId}/variants/${variantId}/`),
};
